<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="promoterUserId" >
        <span slot="label" >
          <a-tooltip>
            {{ $t('推广者用户ID') }}<template slot="title">{{ $t('推广者用户ID') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.promoterUserId"  :placeholder="$t('请输入')+$t('推广者用户ID')" />
      </a-form-model-item>
      <a-form-model-item prop="promoterName" >
        <span slot="label" >
          <a-tooltip>
            {{ $t('推广者昵称/姓名') }}<template slot="title">{{ $t('推广者昵称/姓名') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.promoterName" :maxLength="100" :placeholder="$t('请输入')+$t('推广者昵称/姓名')" />
      </a-form-model-item>
      <a-form-model-item prop="phone" >
        <span slot="label" >
          <a-tooltip>
            {{ $t('手机号') }}<template slot="title">{{ $t('手机号') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.phone" :maxLength="32" :placeholder="$t('请输入')+$t('手机号')" />
      </a-form-model-item>
      <a-form-model-item prop="joinTime" >
        <span slot="label" >
          <a-tooltip>
            {{ $t('入驻时间') }}<template slot="title">{{ $t('入驻时间') }}</template>
          </a-tooltip>
        </span>
        <a-date-picker style="width: 100%" v-model="form.joinTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="status" >
        <span slot="label" >
          <a-tooltip>
            {{ $t('状态 0=禁用 1=正常 2=作废') }}<template slot="title">{{ $t('状态 0=禁用 1=正常 2=作废') }}</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-form-model-item prop="inviteCount" >
        <span slot="label" >
          <a-tooltip>
            {{ $t('邀请人数') }}<template slot="title">{{ $t('邀请人数') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.inviteCount"  :placeholder="$t('请输入')+$t('邀请人数')" />
      </a-form-model-item>
      <a-form-model-item prop="monthOrders" >
        <span slot="label" >
          <a-tooltip>
            {{ $t('本月订单数') }}<template slot="title">{{ $t('本月订单数') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.monthOrders"  :placeholder="$t('请输入')+$t('本月订单数')" />
      </a-form-model-item>
      <a-form-model-item prop="totalOrders" >
        <span slot="label" >
          <a-tooltip>
            {{ $t('累计订单数') }}<template slot="title">{{ $t('累计订单数') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.totalOrders"  :placeholder="$t('请输入')+$t('累计订单数')" />
      </a-form-model-item>
      <a-form-model-item prop="orderAmountSum" >
        <span slot="label" >
          <a-tooltip>
            {{ $t('累计下单金额') }}<template slot="title">{{ $t('累计下单金额') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.orderAmountSum"  :placeholder="$t('请输入')+$t('累计下单金额')" />
      </a-form-model-item>
      <a-form-model-item prop="todayIncome" >
        <span slot="label" >
          <a-tooltip>
            {{ $t('今日收益') }}<template slot="title">{{ $t('今日收益') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.todayIncome"  :placeholder="$t('请输入')+$t('今日收益')" />
      </a-form-model-item>
      <a-form-model-item prop="monthIncome" >
        <span slot="label" >
          <a-tooltip>
            {{ $t('本月收益') }}<template slot="title">{{ $t('本月收益') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.monthIncome"  :placeholder="$t('请输入')+$t('本月收益')" />
      </a-form-model-item>
      <a-form-model-item prop="totalIncome" >
        <span slot="label" >
          <a-tooltip>
            {{ $t('累计收益') }}<template slot="title">{{ $t('累计收益') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.totalIncome"  :placeholder="$t('请输入')+$t('累计收益')" />
      </a-form-model-item>
      <a-form-model-item prop="pendingCommission" >
        <span slot="label" >
          <a-tooltip>
            {{ $t('待结算佣金') }}<template slot="title">{{ $t('待结算佣金') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.pendingCommission"  :placeholder="$t('请输入')+$t('待结算佣金')" />
      </a-form-model-item>
      <a-form-model-item prop="withdrawAble" >
        <span slot="label" >
          <a-tooltip>
            {{ $t('可提现佣金') }}<template slot="title">{{ $t('可提现佣金') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.withdrawAble"  :placeholder="$t('请输入')+$t('可提现佣金')" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getUnionAlliance, addUnionAlliance, updateUnionAlliance } from '@/api/union/unionAlliance'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        promoterUserId: null,

        promoterName: null,

        phone: null,

        joinTime: null,

        status: 0,

        inviteCount: null,

        monthOrders: null,

        totalOrders: null,

        orderAmountSum: null,

        todayIncome: null,

        monthIncome: null,

        totalIncome: null,

        pendingCommission: null,

        withdrawAble: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        promoterUserId: [
          { required: true, message: this.$t('推广者用户ID')+this.$t('不能为空'), trigger: 'blur' }
        ],
        joinTime: [
          { required: true, message: this.$t('入驻时间')+this.$t('不能为空'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('状态 0=禁用 1=正常 2=作废')+this.$t('不能为空'), trigger: 'blur' }
        ],
        inviteCount: [
          { required: true, message: this.$t('邀请人数')+this.$t('不能为空'), trigger: 'blur' }
        ],
        monthOrders: [
          { required: true, message: this.$t('本月订单数')+this.$t('不能为空'), trigger: 'blur' }
        ],
        totalOrders: [
          { required: true, message: this.$t('累计订单数')+this.$t('不能为空'), trigger: 'blur' }
        ],
        orderAmountSum: [
          { required: true, message: this.$t('累计下单金额')+this.$t('不能为空'), trigger: 'blur' }
        ],
        todayIncome: [
          { required: true, message: this.$t('今日收益')+this.$t('不能为空'), trigger: 'blur' }
        ],
        monthIncome: [
          { required: true, message: this.$t('本月收益')+this.$t('不能为空'), trigger: 'blur' }
        ],
        totalIncome: [
          { required: true, message: this.$t('累计收益')+this.$t('不能为空'), trigger: 'blur' }
        ],
        pendingCommission: [
          { required: true, message: this.$t('待结算佣金')+this.$t('不能为空'), trigger: 'blur' }
        ],
        withdrawAble: [
          { required: true, message: this.$t('可提现佣金')+this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        promoterUserId: null,
        promoterName: null,
        phone: null,
        joinTime: null,
        status: 0,
        inviteCount: null,
        monthOrders: null,
        totalOrders: null,
        orderAmountSum: null,
        todayIncome: null,
        monthIncome: null,
        totalIncome: null,
        pendingCommission: null,
        withdrawAble: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getUnionAlliance({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateUnionAlliance(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addUnionAlliance(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
